export default __webpack_public_path__ + "static/media/logo_min.83246223.png";